import styled from 'styled-components';
import {Alert} from 'antd';
import {bordersStyles, typographyStyles} from '../../../../../utils/styles';

const StyledPolicyEditorWithPreview = styled.div`
  ${bordersStyles.light};
  padding: 16px 24px;

  h3 {
    ${typographyStyles.heading.h5};
    color: ${props => props.theme.colors.neutral_10};
    margin: 0;
  }

  p {
    ${typographyStyles.body.regular};
    color: ${props => props.theme.colors.neutral_10};
    margin: 0;
    padding: 0;
  }

  .ql-toolbar.ql-snow {
    border-radius: 4px 4px 0 0;
    border-color: #d9d9d9;
  }

  .ql-editor {
    min-height: 200px;
  }

  .ql-container.ql-snow {
    border-radius: 0 0 4px 4px;
    border-color: #d9d9d9;
  }
`;

const StyledPolicyEditorWithPreviewAlert = styled(Alert)`
  ${typographyStyles.footnote.description};

  background-color: transparent;
  border: none;
  color: ${props => props.theme.colors.functional_warning};
  padding: 0;
`;

const StyledPolicyEditorWithPreviewTitle = styled.div`
  display: flex;
  justify-content: space-between;
`;

export {
  StyledPolicyEditorWithPreview,
  StyledPolicyEditorWithPreviewAlert,
  StyledPolicyEditorWithPreviewTitle
};
